import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAsyncFn } from 'react-use';
import { isSingleOfferProductWithOffer } from '@uno/common-cms';
import Loader from 'components/common/Loader';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { getAffiliationProducts } from 'services/networking/affiliation';
import AffiliationWarning from '../AffiliationWarning/AffiliationWarning';
import { AffiliationSlide, AffiliationSlideDetails, AffiliationSlideImage, AffiliationSlideImageContainer, AffiliationSlideNoOffer, AffiliationSlideOffer, AffiliationSlidePrice, AffiliationSlideshow, AffiliationSlideshowTitle, AffiliationSlideStore, AffiliationSlideTitle, AffiliationSlideWarning, LoaderContainer } from './AffiliationBlockSlideshow.style';

var AffiliationBlockSlideshow = function AffiliationBlockSlideshow(_ref) {
  var entityData = _ref.entityData;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id,
      lang = _useSiteConfig.lang;

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState(undefined),
      selectedProducts = _useState[0],
      setSelectedProducts = _useState[1];

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(affiliationId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return snackAsyncError({
                messageId: 'affiliation.error.get-products',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$getAffiliation, products;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getAffiliationProducts(lang, affiliationId, site);

                          case 2:
                            _yield$getAffiliation = _context.sent;
                            products = _yield$getAffiliation.products;
                            setSelectedProducts(products);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      retrieveProductLoading = _useAsyncFn2[0].loading,
      retrieveProducts = _useAsyncFn2[1];

  useEffect(function () {
    if ((entityData === null || entityData === void 0 ? void 0 : entityData.affiliationId) === undefined) {
      return;
    }

    void retrieveProducts(entityData.affiliationId);
  }, [entityData, retrieveProducts]);

  var Slideshow = function Slideshow() {
    if (selectedProducts === undefined) {
      return __jsx(FormattedMessage, {
        id: 'affiliation.invalid'
      });
    }

    var slides = selectedProducts.map(function (product) {
      var _product$image;

      var affiliationIsBroken = !isSingleOfferProductWithOffer(product);
      return __jsx(AffiliationSlide, {
        key: product.productId,
        "aria-label": "slide - ".concat(product.productId)
      }, __jsx(AffiliationSlideImageContainer, {
        isBroken: affiliationIsBroken
      }, affiliationIsBroken && __jsx(AffiliationSlideWarning, null, __jsx(AffiliationWarning, {
        messageId: 'affiliation.obsolete'
      })), __jsx(AffiliationSlideImage, {
        src: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.imgUrl,
        alt: product.name
      })), __jsx(AffiliationSlideDetails, null, __jsx(AffiliationSlideTitle, {
        title: product.name
      }, product.name), __jsx(AffiliationSlideOffer, null, isSingleOfferProductWithOffer(product) ? __jsx(React.Fragment, null, __jsx(AffiliationSlideStore, {
        title: product.offer.storeName
      }, product.offer.storeName), __jsx(AffiliationSlidePrice, null, product.offer.price, "\u20AC")) : __jsx(FormattedMessage, {
        id: 'affiliation.no-offer',
        tagName: AffiliationSlideNoOffer
      }))));
    });
    return __jsx(AffiliationSlideshow, null, slides);
  };

  return __jsx(React.Fragment, null, entityData.title !== undefined && __jsx(AffiliationSlideshowTitle, null, entityData.title), retrieveProductLoading ? __jsx(LoaderContainer, null, __jsx(Loader, null)) : __jsx(Slideshow, null));
};

export default AffiliationBlockSlideshow;